jQuery( document ).ready(function($) {

    // Init in the backend
    var initPostsLoopMasonry = function( $block ) {
        $block.masonry({
            itemSelector: '.el-padded-wrapper',
            percentPosition: true
        });
    }
  
    // Init on the frontend
    $('.posts-loop-wrapper .inside-wrapper').each(function(){
        initPostsLoopMasonry( $(this) );
    });
  
    // Init in the backend
    if( window.acf ) {
      window.acf.addAction( 'render_block_preview/type=posts_loop', initPostsLoopMasonry );
    }
  });